import type { RequestParams, ScpClient } from '~shared/api/scp/client';

import type {
  SummaryApi,
  SummaryGraphParameters,
  SummaryGraphResponse,
  SummaryTableParameters,
  SummaryTableResponse,
} from '../summary-api';

interface Params {
  scpClient: ScpClient;
  host: string;
}

export class GatewaySummaryApi implements SummaryApi {
  host: string;
  client: ScpClient;

  constructor({ scpClient, host }: Params) {
    this.client = scpClient;
    this.host = host;
  }

  async getGraphData(
    params: SummaryGraphParameters
  ): Promise<SummaryGraphResponse> {
    return this.makeRequest<SummaryGraphResponse>({
      method: 'graph',
      payload: params,
    }).then((response) => response.payload);
  }

  async getTableDataByMerchant(
    params: SummaryTableParameters
  ): Promise<SummaryTableResponse> {
    return this.makeRequest<SummaryTableResponse>({
      method: 'by-merchant',
      payload: params,
    }).then((response) => response.payload);
  }

  async getTableDataByPos(
    params: SummaryTableParameters
  ): Promise<SummaryTableResponse> {
    return this.makeRequest<SummaryTableResponse>({
      method: 'by-point-of-sales',
      payload: params,
    }).then((response) => response.payload);
  }

  private makeRequest<T = unknown>(
    params: Partial<RequestParams> & { method: string }
  ) {
    return this.client.call<T>({
      host: this.host,
      version: 'v1',
      domain: 'merchant-portal',
      service: 'public/dashboard/summary',
      withCredentials: true,
      withLeadingDomain: true,
      ...params,
    });
  }
}
